export const ADMINS_USER_TYPE = ["Master", "Admin"];
export const USERS_USER_TYPE = ["User"];
export const CLIENTS_USER_TYPE = ["Client"];
